export const SummaryChart: ng.IComponentOptions = {
  bindings: {
    options: '='
  },
  templateUrl: 'app/angularJS/components/summary-chart/summary-chart.html',
  controller: 'SummaryChartController',
  controllerAs: 'vm'
};